module.exports = __webpack_public_path__ + "img/W-M101.8dcd698a.jpg";